import { makeStyles } from 'beam'
import { useFeatureAvailable } from '../../FeatureFlags'
import { useUser } from '../../Permissions'
import ConeIdleTimer from '../../Common/ConeIdleTimer'
import { MaintenanceNotificationDialog } from '../../Common/MaintenanceNotficationDialog'
import FedRAMPCompliance from '../FedRAMPCompliance'

const useStyles = makeStyles(theme => ({
  content: {
    flex: '1 1 auto',
    height: `calc(100vh - ${theme.spacing(8)}px)`, // TODO: reference calabrio theme value for header +footer height height once it is added
    overflow: 'auto',
  },
}))

const PostAuthRoutes: React.FC = ({ children }) => {
  const user = useUser()
  const classes = useStyles()
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TODO: remove type assertion
  const fedRAMPComplianceMessage = useFeatureAvailable('cher.fedramp-login-banner') as string // TODO: useFeatureAvailable() return type is `string | boolean`; remove this type coercion and update the code accordingly

  const showFedRAMPCompliance = !!fedRAMPComplianceMessage && !user?.fedRAMPCompliance

  return showFedRAMPCompliance
    ? <FedRAMPCompliance />
    : (
      <>
        <ConeIdleTimer />
        <MaintenanceNotificationDialog />
        <div className={classes.content}>{children}</div>
      </>
    )
}

export default PostAuthRoutes
